import { useState, useCallback, useEffect } from 'react';
import cx from 'classnames';
import axios from 'Axios';
import Autosuggest from 'react-autosuggest';
import debounce from 'lodash.debounce';
import { Search } from 'tabler-icons-react';
import { useDispatch } from 'react-redux';
import { setSelectedMarker } from 'Actions';
import { Link, useParams } from 'react-router-dom';
import { api, Names, slugify } from 'Utils';
import { Button } from 'Elements';
import styles from 'partials/search-box.module.scss';
import autosuggestStyle from 'partials/autosuggest.module.scss';

export const SearchBox = ({ className }) => {
	const dispatch = useDispatch();
	const pageParams = useParams();
	const [query, setQuery] = useState('');
	const [suggestions, setSuggestions] = useState([]);

	const handleInput = (e, { newValue }) => {
		setQuery(newValue);
	};

	const submitSelected = (selected) => {
		if (!query) {
			return false;
		} else {
			dispatch(setSelectedMarker(selected));
		}
	};

	const onSuggestionSelected = (e, { suggestion }) => {
		submitSelected(suggestion);
	};

	const handleForm = (e) => {
		e.preventDefault();
	};

	// Teach Autosuggest how to calculate suggestions for any given input value.
	const getSuggestions = (value) => {
		const inputValue = value.trim().toLowerCase();
		const inputLength = inputValue.length;
		inputLength === 1
			? setSuggestions([])
			: axios.get(api.search(inputValue)).then((response) => {
					const list = response.data.list;
					if (list && list?.length !== 0) {
						setSuggestions(list);
					}
			});
	};

	const loadSuggestions = (value) => {
		getSuggestions(value);
	};

	const getSuggestionValue = (suggestion) => suggestion.title;

	const renderSuggestion = (suggestion) => {
		return (
			<Link
				to={`${Names.story.path}/${suggestion.id}/${slugify(
					suggestion.slug
				)}`}
				className={styles.row}
				title={suggestion.title}>
				{suggestion.title}
			</Link>
		);
	};

	// eslint-disable-next-line
	const debouncedGetSuggestions = useCallback(
		debounce(loadSuggestions, 300),
		[]
	);

	const onSuggestionsFetch = ({ value, reason }) => {
		if (reason === 'input-focused') {
			return;
		}
		debouncedGetSuggestions(value);
	};

	const onSuggestionsClear = () => {
		setSuggestions([]);
	};

	useEffect(() => {
		let params = pageParams?.story_slug
			? pageParams.story_slug.replace(/-/g, ' ')
			: '';
		setQuery(params);
	}, [pageParams.story_slug]);

	const inputProps = {
		autoComplete: 'false',
		type: 'search',
		className: styles.input,
		placeholder: 'جستجو...',
		value: query,
		onChange: handleInput
	};

	const searchClass = cx(styles.box, className);
	return (
		<form className={searchClass} onSubmit={handleForm}>
			<Autosuggest
				highlightFirstSuggestion
				theme={autosuggestStyle}
				suggestions={suggestions}
				onSuggestionsFetchRequested={onSuggestionsFetch}
				onSuggestionsClearRequested={onSuggestionsClear}
				onSuggestionSelected={onSuggestionSelected}
				getSuggestionValue={getSuggestionValue}
				renderSuggestion={renderSuggestion}
				inputProps={inputProps}
			/>
			<Button type="submit" className={styles.submit}>
				<Search />
			</Button>
		</form>
	);
};
